// extracted by mini-css-extract-plugin
module.exports = {"container":"OverviewCard-module__container--3MR6S","containerHover":"OverviewCard-module__containerHover--24fzV","bottom":"OverviewCard-module__bottom--E8r6m"};